import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../Home.module.css';

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL;

const CallToAction = () => (
  <section className={styles.footcta}>
    <div className={styles.container}>
      <span className={`${styles.eyebrow} ${styles.sr}`} data-sr><span className={styles.dot} />Get started</span>
      <h2 className={styles.sr} data-sr style={{ marginTop: 18 }}>Start getting paid with Fyntiq.</h2>
      <p className={styles.sr} data-sr>Set up in minutes. No setup fees, free to start.</p>
      <div className={styles.sr} data-sr>
        <Link to={`${dashboardUrl}/signup`} className={styles.btnYellow}>Create your account</Link>
      </div>
    </div>
  </section>
);

export default CallToAction;
